import { CountriesType } from '../../../core/components/language-selector/CountriesType';
import { IOptionField } from '../../interfaces/IOptionField';

export const DocumentTypes: {
	[key in CountriesType]: IOptionField[];
} = {
	[CountriesType.BR]: [
		{ name: 'CNPJ', code: 'CNPJ' },
		{ name: 'CPF', code: 'CPF' },
	],
	[CountriesType.MX]: [
		{ name: 'RFC', code: 'RFC' },
		{ name: 'CURP (DNI)', code: 'CURP' },
	],
	[CountriesType.CO]: [
		{ name: 'Cedula', code: 'CC' },
		{ name: 'RUT', code: 'RUT' },
	],
};
